<template>
    <div class="row">
        <div class="col-12 mb-1">
            <span v-html="value.Content"></span>
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    
}
</script>

<style>

</style>